var render = function () {
  var _ref;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('input-link', {
    ref: "accountLink",
    attrs: {
      "input-id": "input-link",
      "data-test": "accountCreatingProjectLinkInput",
      "input-name": _vm.$t('link.to.project.or.account'),
      "input-title": _vm.$t('indicate.link.to.project.or.account'),
      "input-placeholder": _vm.$t('common.link'),
      "required": false,
      "disabled": _vm.loading,
      "max-length": 500,
      "capusta-info": "registration"
    },
    on: {
      "focus": function focus($event) {
        _vm.isFocusOnAccountLink = true;
      },
      "blur": function blur($event) {
        _vm.isFocusOnAccountLink = false;
      }
    },
    model: {
      value: _vm.accountLink,
      callback: function callback($$v) {
        _vm.accountLink = $$v;
      },
      expression: "accountLink"
    }
  }), _c('div', {
    class: [_vm.$style.submit, (_ref = {}, _ref[_vm.$style.primary] = _vm.isShownPrimarySubmitButton, _ref)]
  }, [_c('simple-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isShownPrimarySubmitButton,
      expression: "isShownPrimarySubmitButton"
    }],
    attrs: {
      "variant": "secondary",
      "disabled": !_vm.isValid
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.proceed')) + " ")]), _c('simple-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isShownPrimarySubmitButton,
      expression: "!isShownPrimarySubmitButton"
    }],
    attrs: {
      "variant": "darken",
      "size": "small"
    },
    on: {
      "click": _vm.handleAlternativeSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('registration.account.submit.alternative')) + " ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }